module.exports = __webpack_public_path__ + "img/bracket-1.ed4d535c.svg";